/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Intro_LedeInputs */

const tr_landing_intro_lede = /** @type {(inputs: Landing_Intro_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daha fazla özellik, sınırsız destek; üstelik gizli modül ücreti yok. Tek abonelik, gelecek güncellemeler dahil.`)
};

const en_landing_intro_lede = /** @type {(inputs: Landing_Intro_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More features, unlimited support; and zero hidden module fees. One subscription, future updates included.`)
};

const de_landing_intro_lede = /** @type {(inputs: Landing_Intro_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr Funktionen, unbegrenzter Support; obendrein keine versteckten Modulgebühren. Ein Abo, künftige Updates inklusive.`)
};

const ru_landing_intro_lede = /** @type {(inputs: Landing_Intro_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Больше возможностей, безлимитная поддержка; и никаких скрытых платежей за модули. Одна подписка, будущие обновления включены.`)
};

/**
* | output |
* | --- |
* | "More features, unlimited support; and zero hidden module fees. One subscription, future updates included." |
*
* @param {Landing_Intro_LedeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_intro_lede = /** @type {((inputs?: Landing_Intro_LedeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Intro_LedeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_intro_lede(inputs)
	if (locale === "de") return de_landing_intro_lede(inputs)
	if (locale === "ru") return ru_landing_intro_lede(inputs)
	return tr_landing_intro_lede(inputs)
});